<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <img src="/img/placeholder-img.svg" width="75" v-bind="attrs"
             v-on="on" />
      </template>
      <span>{{ labalWithDefault }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "MediaGalleryBtn",
  props: { label: String },
  computed: {
    labalWithDefault() {
      return this.label || this.$t('pages.createGame.media')
    }
  }
};
</script>

<style scoped>
img {
  cursor: pointer;
}

</style>
